import React from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { ContentCopy as ContentCopyIcon } from '@mui/icons-material';
import MarkdownRenderer from '../../../../components/Common/MarkdownRenderer';

const OUTLINE_META_KEYS = new Set([
  'id', 'section_title_id', 'introduction_id', 'summary_id', 'definition_id',
  'question_id', 'answer_id', 'explanation_id', 'proof_id', 'theorem_id',
]);

function getOutlineEntries(outline) {
  if (!outline?.outlines || typeof outline.outlines !== 'object') return [];
  return Object.entries(outline.outlines).filter(
    ([key, val]) => !OUTLINE_META_KEYS.has(key) && typeof val === 'string'
  );
}

export default function OutlineDialog({ open, onClose, notebookData }) {
  const outline = notebookData?.outline;
  const entries = outline ? getOutlineEntries(outline) : [];

  const handleCopy = () => {
    if (!outline) return;
    const lines = [
      `# ${outline.notebook_title || ''}`,
      outline.notebook_description ? `\n${outline.notebook_description}\n` : '',
      '\n## 章节\n',
      ...entries.map(([t, d]) => `- **${t}**${d ? `\n  ${d}` : ''}`),
    ];
    navigator.clipboard?.writeText(lines.join('')).then(() => {}).catch(() => {});
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>本笔记本大纲</DialogTitle>
      <DialogContent>
        {outline ? (
          <Box sx={{ pt: 0.5 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>标题</Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>{outline.notebook_title || '（无）'}</Typography>
            {outline.notebook_description && (
              <>
                <Typography variant="subtitle2" color="text.secondary" gutterBottom>简介</Typography>
                <Box sx={{ mb: 2 }}>
                  <MarkdownRenderer content={outline.notebook_description} />
                </Box>
              </>
            )}
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>章节</Typography>
            {entries.length > 0 ? (
              <Box component="ol" sx={{ m: 0, pl: 2.5, '& li': { mb: 1.5 } }}>
                {entries.map(([title, desc], idx) => (
                  <li key={idx}>
                    <Typography variant="body2" fontWeight={500}>{title}</Typography>
                    {desc && <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>{desc}</Typography>}
                  </li>
                ))}
              </Box>
            ) : (
              <Typography variant="body2" color="text.secondary">暂无章节</Typography>
            )}
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary">暂无大纲数据</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button startIcon={<ContentCopyIcon />} onClick={handleCopy} disabled={!outline}>
          复制大纲
        </Button>
        <Button onClick={onClose}>关闭</Button>
      </DialogActions>
    </Dialog>
  );
}
